export var ZERO_PRICE_LABEL = '$0.00';